var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingRefillsIconmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .48c-1.379 0-2.726.24-4.007.716l.334.9A10.522 10.522 0 0112 1.44c5.823 0 10.56 4.737 10.56 10.56S17.823 22.56 12 22.56 1.44 17.823 1.44 12a10.56 10.56 0 013.84-8.14V7.2h.96V2.4h-4.8v.96h2.94A11.523 11.523 0 00.48 12c0 6.352 5.168 11.52 11.52 11.52 6.352 0 11.52-5.168 11.52-11.52C23.52 5.648 18.352.48 12 .48z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12 15.84h-.96v.96h7.68v-.96h-.96v-1.639L12.679 12l2.201-2.201V8.16h.96V7.2H8.16v.96h.96v1.639L11.321 12 9.12 14.201v1.639zm.96-6.439V8.16h3.84v1.241L12 11.321l-1.92-1.92zM12 12.68l1.92 1.92v1.241h-3.84v-1.241l1.92-1.92zM10.08 18.72h-.96v.96h.96v-.96zM12.48 18.72h-.96v.96h.96v-.96zM14.88 18.72h-.96v.96h.96v-.96z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingRefillsIconmin);
export default __webpack_public_path__ + "static/media/PendingRefillsIcon.min.23ab7ba38506887b791b016e25d6628b.svg";
export { ForwardRef as ReactComponent };